const de = {
  grannbox_onboarding: {
    login_header: "Anmelden bei ihopa",
    login_subheader:
      "Nachdem Sie sich in Ihr Konto eingeloggt haben, werden Sie auf unsere Zahlungsseite weitergeleitet.",
    forgot_pass_header: "Passwort wiederherstellen",
    forgot_pass_subheader:
      "Fügen Sie Ihre ihopa-E-Mail hinzu und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
    create_account_header: "Benutzerkonto erstellen",
    create_account_subheader:
      "Nachdem Sie Ihr kostenloses ihopa-Konto erstellt haben, werden Sie auf unsere Zahlungsseite weitergeleitet.",
    login_continue: "Anmelden & fortfahren",
    back_to_login: "Zurück zur Anmeldung",
    new_to_ihopa: "Neu bei Ihopa? Ihr gratis Konto erstellen",
    already_have_account: "Ein Konto haben? Anmeldung",
    why_phone: "We need it to send you sms:es",
    why_address: "To enable the right product selection",
    continue: "Weitermachen",
    phone_number: "Telefonnummer",
  },
  menu: {
    home: "Home",
    how_it_works: "So funktioniert's",
    why_co_own: "Wieso zusammen kaufen?",
    about_us: "Über uns",
    sign_up: "Anmelden",
    login: "Einloggen",
    logout: "Ausloggen",
    dashboard: "Meine Gruppen",
    account: "Mein Profil",
    messages: "Mitteilungen",
    notifications: "Benachrichtigungen",
    my_circles: "Meine Gruppen",
    dont_have_account: "Noch kein Konto?",
    forgot_password: "Passwort vergessen?",
    register_here: "Registriere dich hier",
    recover_password: "Passwort wiederherstellen",
    terms_of_use: "Nutzungsbedingungen",
    privacy_policy: "Datenschutz-Bestimmungen",
    partners: "Unsere Partner",
    ihopa_for_business: "ihopa für deinen Shop",
    press: "Press",
  },
  why_co_own: {
    cta: "JETZT ZUSAMMEN KAUFEN",
    our_partners: "Unsere Partner",
  },
  sign_up: {
    title: "Registrierung",
    read_and_accept: "Ich akzeptiere die",
    register: "Profil erstellen",
    next_step: "Next step",
    login_here: "Hier geht’s zum Login",
    have_account: "Bereits registriert?",
    placeholders: {
      email_address: "Emailadresse",
      first_name: "Vornamen",
      last_name: "Nachnamen",
      password: "Passwort",
    },
  },
  login: {
    title: "Login",
    placeholders: {
      email_address: "Emailadresse",
      password: "Passwort",
    },
  },
  cookie_conset: {
    message:
      "ihopa.com benutzt Cookies um Ihre Erfahrung auf der Seite zu verbessern. Cookies werden auf fast jeder Webseite benutzt und sind kleine Textdateien die auf Ihrem Gerät gespeichert werden und beispielsweise die Ladegeschwindigkeit verbessern und sichergehen dass du für dich relevante Information liest. Wir nutzen auch Cookies von Drittanbietern (z.b. Google) um die Seite für dich ständig zu verbessern. Cookies sind ungefährlich und Sie können diese jederzeit löschen.Durch die Nutzung von ihopa.com stimmst du der Verwendung von Cookies zu",
    button: "Zustimmen",
  },
  home: {
    hero: {
      how_it_works: "So funktioniert’s",
      learn_more: "Mehr zum Thema",
    },
    co_buy: {
      button_text: "Teilen starten",
    },
    prylpoolen: {
      button_text: "Mehr erfahren",
    },
    circle_collection: {
      heading: "Offene Gruppen",
      subheading: "Diese Gruppen suchen noch Mitkäufer",
    },
    circle_suggestions: {
      heading: "Unsere Vorschläge: Starte deine eigene Gruppe",
      subheading: "Nicht sicher was sich zum Teilen eignet? Hier einige Vorschläge",
    },
    trustpilot_rating: "Bewertet mit 4,8 von 5",
    havent_found_heading: "Jetzt mit dem Teilen starten",
    havent_found_subheading: "Einfach und sicher",
    request_circle: {
      heading: "Neues Produkt anfordern",
      sub_heading: "Sag uns einfach wovon du träumst und wir finden passende Mitkäufer für dich",
      button: "Match mich",
    },

    ready_to_co_own: {
      heading: "Bereit zum Teilen?",
      sub_heading:
        "Spare Geld und rette die Umwelt mit nachhaltigem Konsum. Kaufe einfach zusammen mit Freunden oder Nachbarn. Win-win-win.",
      button: "Jetzt starten",
      faq_button: "Lesen Sie die FAQs",
    },
  },
  circle: {
    per_month: "Per month",
    circle_creator: "Gruppeninitiator",
    start_co_owning: "Beitreten",
    commitment_info:
      "Mit einem Beitrittsgesuch lässt du die Kaufgruppe wissen dass du interessiert bist mitzumachen. Du verpflichtest dich aber zu nichts und kannst die Gruppe jederzeit wieder verlassen.",
    per_person: "pro Person",
    location: "Standort",
    spot_left: "Plätze übrig",
    ready_to_co_own: "Bereit zum Teilen?",
    co_owners: "Mitkäufer",
    lets_start: "Jetzt starten",
    in: " in ",
    white_monday_join: "Beitreten",
  },
  circle_members: {
    heading: "Gruppenmitglieder",
    circle_creator: "Gruppeninitiator",
    circle_member1: "Vor ",
    circle_member2: " beigetreten",
    make_admin: "Zum Administrator machen",
    kick_user: "Mitglied aus Gruppe entfernen",
    migrate_members: "Migrate members to this circle",
    copy_members: "Copy members",
    source_circle: "Source circle guid",
  },
  member_requests: {
    accept: "Annehmen",
    reject: "Ablehnen",
    pending_request: "Beitrittsanfragen",
  },
  new_circle: {
    create: "Initiative starten",
    heading: "Gruppe erstellen",
    subheading: "Lade deine Freunde an und teile die Gruppe auf Social Media",
    create_a_circle: "Gruppe erstellen",
    did_not_find: "Keine offenen Gruppen gefunden.",
    did_not_find_description:
      "Wir haben leider keine offenen Gruppen in deiner Umgebung gefunden. Starte einfach eine neue.",
    public_circle_switch: "Für alle sichtbar",
    pre_owned_switch: "Bereits vorhandenes Produkt",
    agreement_switch: "Mitglieder sollen eine Vereinbarung unterschreiben",
    public_circle_title: "Was bedeutet Für alle sichtbar ",
    pre_owned_title: "Was bedeutet Bereits vorhandenes Produkt",
    agreement_title: "Was ist eine Vereinbarung?",
    agreement_explain:
      "Um Unstimmigkeiten vorzubeugen ist es sinnvoll eine schriftliche Vereinbarung zu treffen die das gemeinsame Kaufen und die gemeinsame Nutzung regelt. Wir haben mit Hilfe der Erfahrungen unserer Nutzer diese Teil-Vereinbarung geschrieben. Natürlich könnt ihr sie ändern und wir helfen euch gerne dabei.",
    public_circle_explain:
      "Für alle sichtbar heißt dass deine Gruppe auf der ihopa Plattform angezeigt wird und unsere Nutzer dir ein Beitrittsgesuch senden können. Natürlich kannst du immer bestimmen wen du annimmst. Wenn du die Gruppe nur mit Freunden machen willst und sie selber auch deinen Social Media teilen willst kannst du diese Funktion abschalten. Jeder mit dem Link kann die Gruppe sehen. ",
    pre_owned_explain: "Für Sachen die du bereits besitzt und einen Teilhaber suchst.",
    create_circle_button: "Gruppe starten",
    edit_circle_button: "Gruppe aktualisieren",
    preview_agreement_button: "Vorschau der Vereinbarung",
    is_prylpoolen_switch: "Is Prylpoolen",
    is_prylpoolen_title: "Is prylpoolen title",
    is_prylpoolen_explain: "Is prylpoolen explain",
    booking_limitations_title: "Booking limitation",
    booking_limitations_explain:
      "Here you can set limitations to each members bookings. Max. number of bookings refers to how many single booking a member can do in advance. You can also limit maximum time of each booking.",
    unlimited: "Unlimitiert",
    labels: {
      add_product_image: "Foto hinzufügen",
      product_name: "Produkt- / Gruppenname",
      product_category: "Produktkategorie",
      product_price: "Produktpreis",
      product_url: "Productlink",
      description: "Beschreibe deine Gruppe",
      number_of_owners: "Anzahl von Miteigentümern",
      max_active_bookings: "Maximale Anzahl an aktiven Buchungen",
      max_booking_duration: "Maximale Dauer einer Buchung",
      circle_status: "Circle status",
      door_id: "Door ID",
    },
    placeholders: {
      paste_image_url: "Hier link zum Produkt einfügen. Dies kann auch nur ein Beispielprodukt sein",
      product_name_suggestion: "z.b. Kajak",
      select_category: "Wähle eine Kategorie",
      add_price: "Gesamtpreis des Produktes angeben",
      url_suggestion: "https://webseite.com/produkt",
      description_placeholder:
        "Beschreibe deine Vorstellung, deinen optimalen Mitkäufer oder schreib einfach warum du diese Gruppe startest",
      door_id: "Door ID",
    },
  },
  new_expense: {
    placeholders: {
      expense: "Ausgabe für",
      price: "€",
    },
  },
  new_usage_log: {
    placeholders: {
      description: "Gebrauchsbeschreibung ",
      value: "Anzahl",
      unit: "Einheit",
    },
    options: {
      km: "Kilometer",
      hrs: "Stunden",
      min: "Minuten",
    },
  },
  circle_admin: {
    members: "Gruppenmitglieder",
    per_person: "pro Person",
    location: "Standort",
    paragraph1: "Die Gruppe braucht noch ",
    paragraph2: " Mitkäufer. Lade deine Freunde ein!",
    share_button: "Link kopieren",
    share_button_facebook: "Teilen",
    sign_agreement_notification:
      "Bitte unterschreibe die Vereinbarung. Falls du die anderen Mitglieder noch nicht kennst empfehlen wir ein Treffen der ganzen Gruppe um das Vertrauen zu stärken und neue Freundschaften zu schließen.",
    wait_others_sign_agreement: "Nun warten wir bis alle Mitglieder die Vereinbarung unterschrieben haben. ",
    wait_for_purchase: "Alle haben der Vereinbarung zugestimmt. Nun wird der Gruppeninitiator das Produkt kaufen",
    admin_purchase_item:
      "Alle Mitglieder haben der Vereinbarung zugestimmt. Nun kannst du das Produkt kaufen und das Geld einsammeln. Die Vereinbarung ist bindend.",
    purchase_button: "Produkt ist gekauft",
    sign: "Unterschreiben",
    already_signed: "hat die Vereinbarung bereits unterschrieben und wartet darauf dass auch du unterschreibst.",
    copied_to_clipboard: "Link kopiert",
    share_on_facebook: "Teile diese Gruppe",
  },
  circle_status: {
    member_gathering: "Suche Mitglieder",
    awaiting_purchase: "Warten auf den Produktkauf",
    progress: "In Bearbeitung",
    pending: "Wartend",
    awaiting_commitment: "Warten auf Unterschriften",
    completed: "Bereit",
  },
  public_profile: {
    profile: "`s Profil",
    send_message: "Mitteilung senden",
    about: "Über mich ",
    location: "Standort",
    member_since: "Mitglied seit ",
    user_circles: "'s Gruppen",
    not_in_circles: "ist noch keiner Gruppe beigetreten",
    create_circle_with_him: "Starte eine Gruppe und teile mit Ihm/Ihr",
    create_circle: "Starte eine neue Gruppe",
    sidebar_right_heading: "Gruppen",
  },
  user_details: {
    member_since: "Mitglied seit",
    save_profile: "Profil speichern",
    public_profile: "Öffentliches Profil",
    labels: {
      first_name: "Vorname",
      last_name: "Nachname",
      email: "Email",
      location: "Dein Standort",
      description: "Über dich",
      change_password: "Passwort ändern",
      confirm_password: "Passwort bestätigen",
    },
    placeholders: {
      first_name: "Max",
      last_name: "Mustermann",
      email: "max.mustemannr@domain.com",
      location: "Adresse",
      description: "Wer du bist, wieso du am Teilen interessiert bist, welche Hobbies du hast...",
      change_password: "Freilassen wenn du das Passwort nicht ändern möchtest",
      confirm_password: "Freilassen wenn du das Passwort nicht ändern möchtest",
      mobile_phone: "Telefonnummer +49...",
    },
  },
  user_activation_banner: {
    heading: "Bitte aktiviere dein Konto!",
    resend_activation_email: "Aktivierungslink neu senden",
    paragraph1: "Wir haben dir eine Email mit dem Aktivierungslink zugesandt ",
    paragraph2: "Das Email ist noch nicht angekommen?",
  },
  collection_page: {
    owners_suggested: "Miteigentümer empfohlen",
    heading: "Vorschläge: Starte deine eigene Gruppe",
    subheading: "Nicht sicher was sich zum Zusammen Kaufen eignet? Hier einige Vorschläge von unserem Team",
    opened_circles_heading: "Offene Kaufgruppen",
    opened_circles_subheading: "Trete existierenden Initiativen bei",
  },
  recover_password: {
    heading: "Passwort wiederherstellen",
    button: "Passwort wiederherstellen",
    email_placeholder: "Email",
  },
  reset_password: {
    change_password: "Passwort ändern",
    button: "Passwort ändern",
    password_placeholder: "Neues Passwort",
    password_repeat_placeholder: "Neues Passwort wiederholen",
  },
  suggestion: {
    per_person: "pro Person",
  },
  general_messages: {
    no_circles: "Keine Gruppe gefunden",
    load_more: "Mehr anzeigen",
    send_request: "Beitrittsgesuch senden",
    find_match: "Lass uns eine passende Gruppe für dich finden",
  },
  google_maps_modal: {
    title: "Gruppen Standort",
    save_location: "Standort speichern",
  },
  profile_completeness: {
    heading: "Profil Vollständigkeit ",
    subheading: "Mit einem vollständigen Profil hast du größere Chancen von einer Gruppe akzeptiert zu werden.",
    add_avatar: "Foto hinzufügen",
    add_address: "Deine Adresse",
    about_you: "Etwas über dich",
  },
  booking: {
    select_period: "Wähle den Buchungszeitraum aus",
    days_booked: " Tage gebucht",
    overlapping_interval: "Überlappende Buchung",
    cancel_booking: "Buchung löschen",
    user_booking: "Buchung",
    save_booking: "Buchen",
    start_date: "Startdatum",
    end_date: "Enddatum",
    existing_bookings: "Gebuchte Zeiten",
    subscription: "Subscription",
  },
  expenses: {
    user: "Mitglied",
    spent: "Ausgabe von",
    ago: " her",
    total_spent: " totale Ausgaben",
  },
  messaging: {
    title: "Mitteilungen",
    new_message_button: "Neue Mitteilung",
    messages_inside_circles_label: "Gruppenmitteilungen",
    personal_messages_label: "Persönliche Mitteilungen",
  },
  notifications: {
    title: "Benachrichtigungen",
    no_notifications: "Du bist auf dem neuesten Stand",
    setup_circle: "Willst du noch mehr sparen und eine neue Gruppe gründen?",
    create_circle: "Neue Gruppe starten",
  },
  request_circle: {
    labels: {
      description: "Gruppenbeschreibung ",
    },
    placeholders: {
      description: "Beschreibe die Initiative; Was du kaufen willst, wie du dir das teilen vorstellst,... ",
    },
  },
  my_circles: {
    heading: "Meine Gruppen",
    create_circle: "Neue Gruppe starten",
    circles_near_you: "Gruppen in deiner Nähe",
    you_have_no_circles: "Du bist noch keiner Gruppe beigetreten",
    setup_new_circle: "Wieso warten? Starte eine neue Gruppe und wir helfen dir diese zu füllen.",
  },
  errors: {
    commitment: {
      fetch: "Fehlende Unterschriften (Fehler fetch)",
      sign: "Bei der Unterschrift ist was schiefgegangen. Bitte versuchs nochmal.",
    },
    login: {
      invalid_email: "Ungültige Email-Adresse",
      password_required: "Bitte leg ein Passwort fest",
    },
    register: {
      invalid_email: "Ungültige Email-Adresse",
      invalid_first_name: "Bitte sag uns wie du heißt - fürs Vertrauen ist der Name wichtig.",
      invalid_last_name: "Bitte sag uns wie du heißt - fürs Vertrauen ist der Name wichtig.",
      password_to_short: "Passwort ist zu kurz- Mach es sicherer und benutze mindestens 6 Buchstaben oder Nummern",
      accept_terms: "Bitte stimme den Nutzungsbedingungen zu",
    },
    circle_collection: {
      fetch: "Hoppla, Fehler beim Zugriff zur Kategorie",
      unhandled: "Hoppla, ein unbekannter Fehler beim Zugriff zur Kategorie ist aufgetreten. ",
    },
    circle_suggestions: {
      fetch: "Hoppla, ein Fehler beim Zugriff auf unsere Vorschläge ist aufgetreten",
      unhandled: "Hoppla, ein unbekannter Fehler beim Zugriff auf unsere Vorschläge ist aufgetreten.",
    },
    iam: {
      login:
        "Wir konnten die angegebene Email/Passwort Kombination leider nicht finden. Versuchs nochmal! Alternativ kannst du das Passwort wiederherstellen.",
      register:
        "Hoppla, hier ist was mit der Erstellung deines Kontos schiefgegangen. Bitte versuch es später nochmal oder kontaktiere uns.",
      register_duplicated: "Hoppla, diese Email wird bereits verwendet. Begib dich bitte zum Login um dich einzuloggen",
      session_expired:
        "Deine Session ist aus Sicherheitsgründen abgelaufen weil du zu lange inaktiv warst. Log dich einfach nochmal ein.",
    },
    users: {
      fetch: "Hoppla, ein Fehler beim Zugriff auf dein Konto ist aufgetreten",
      update:
        "Hoppla, Es gab ein Problem mit der Aktualisierung deines Profils. Versuchs nochmal oder kontaktiere uns.",
      error_on_reset_password:
        "Hoppla, es gab ein Problem dein Passwort wiederherzustellen. Versuchs nochmal oder kontaktiere uns. ",
      resend_activation_email:
        "Hoppla, es gab ein Problem dein dir einen Wiederherstellungslink per Email zu schicken. Versuchs nochmal oder kontaktiere uns.",
    },
    update_user_details: {
      description: "Schreib was über dich",
      passwords_not_matching: "Die eingegebenen Passwörter stimmen nicht überein",
      error_on_activate_account:
        "Hoppla, es gab ein Problem dein Konto zu aktivieren. Versuchs nochmal oder kontaktiere uns.",
    },
    new_circle: {
      valid_url:
        "Bitte gib einen gültigen Link an. Es ist einfacher wenn du den Link vom Browser kopierst und hier einfügst. ",
      product_name: "Bitte gib einen Produktnamen",
      description: "Beschreibe deine Gruppe",
      add_product_price: "Bitte gib den Gesamtpreis des Produktes an",
      add_product_image: "Füge bitte ein Bild des Produktes hinzu",
      add_location: "Bitte gib den voraussichtlichen Standort des Produktes an",
      image_to_big: "Hoppla, dieses Bild ist zu groß. Bitte lade eines mit max. 3MB hoch.",
    },
    save_circle: {
      error_on_save: "Hoppla, es gab ein Problem die Gruppe zu speichern. Versuchs nochmal oder kontaktiere uns.",
    },
    member_requests: {
      fetch:
        "Hoppla, es gab ein Problem die Beitrittsgesuche für diese Gruppe zu laden. Versuchs nochmal oder kontaktiere uns.",
      update:
        "Hoppla, es gab ein Problem die Beitrittsgesuche für diese Gruppe zu aktualisieren. Versuchs nochmal oder kontaktiere uns.",
      already_member: "Du bist dieser Gruppe bereits beigetreten",
      already_send_join_request:
        "Du hast dieser Gruppe bereits ein Beitrittsgesuch zugesandt. Versuch den Gruppeninitiator eine Nachricht zu schreiben oder kontaktier uns und wir erinnern Sie/Ihn.",
      join_request: "Hoppla, es gab ein Problem mit dem Beitrittsgesuch. Versuchs nochmal oder kontaktiere uns.",
    },
    my_circles: {
      fetch: "Hoppla, es gab ein Problem deine Gruppen zu laden. Versuchs nochmal oder kontaktiere uns.",
      mark: "Hoppla, es gab ein Problem das Produkt als gekauft zu markieren. Versuchs nochmal oder kontaktiere uns.",
      migrate: "Error on migrating users",
    },
    bookings: {
      fetch: "Hoppla, es gab ein Problem deine Buchungen zu laden. Versuchs nochmal oder kontaktiere uns.",
      add_booking: "Hoppla, es gab ein Problem deine Buchung zu speichern. Versuchs nochmal oder kontaktiere uns.",
      MaxBookingDurationExceeded:
        "Deine Buchung überschreitet das Buchungslimit für diese Gruppe. Bitte versuche eine kürzere Buchungsdauert.",
      MaxActiveBookingsExceeded:
        "Du hast die maximale Buchungsnummer überschritten. Bitte lösche eine andere Buchung oder warte bis nach deiner nächsten Buchung um eine neue zu erstellen.",
    },
    expenses: {
      fetch: "Hoppla, es gab ein Problem die Auslagen zu laden. Versuchs nochmal oder kontaktiere uns.",
      register_expense:
        "Hoppla, es gab einen Fehler die neue Auslage zu speichern. Versuchs nochmal oder kontaktiere uns.",
      add_booking: "Hoppla, es gab ein Problem die Auslagen zu speichern. Versuchs nochmal oder kontaktiere uns.",
      add_price: "Bitte definiere die Höhe deiner Auslage ",
      add_expense: "Bitte lass deine Gruppe wissen wofür diese Auslage verwendet wurde.",
    },
    usage_logs: {
      fetch: "Hoppla, es gab ein Problem die Logs zu laden. Versuchs nochmal oder kontaktiere uns.",
      register_usage:
        "Hoppla, es gab einen Fehler beim Speichern des neuen Logs. Versuchs nochmal oder kontaktiere uns.",
      add_usage_description: "Gib der Anwendung eine kurze Erklärung",
      add_value: "Gib der Anwendung einen Zahlenwert",
      add_unit: "Bitte wähle die Einheit der Anwendung aus",
    },
    request_circle: {
      description: "Bitte lass uns wissen was du gerne in einer Gruppe kaufen möchtest",
    },
    sharing_box: {
      checkout_session: "Something went wrong on Stripe, please try again.",
    },
    rental_session: {
      fetch: "Something went wrong on Stripe, please try again.",
    }
  },
  success: {
    commitment: {
      sign: "Super, du hast die Vereinbarung unterschrieben und bald kannst weitergehen.",
    },
    iam: {
      login: "Willkommen zurück",
      register:
        "Dein Profil wurde erfolgreich erstellt. Willkommen! Wir haben dir per Email einen Aktivierungslink zugesandt. Bitte klicke den um ihopa unbeschränkt zu nutzen. ",
    },
    update_user_details: {
      successfully_saved: "Deine Änderungen wurden erfolgreich gespeichert",
      successfully_changed_password: "Dein Passwort wurde erfolgreich aktualisiert",
      recover_email_send: "Du hast eine Email mit dem Wiederherstellungslink erhalten ",
      successfully_activated_account: "Dein Konto wurde erfolgreich aktiviert ",
      resend_activation_email: "Wir haben dir den Aktivierungslink per Email geschickt",
    },
    save_circle: {
      successfully_saved: "Die Gruppendetails wurden erfolgreich gespeichert",
    },
    member_requests: {
      update: "Das Beitrittsgesuch wurde erfolgreich aktualisiert",
      join_request: "Dein Beitrittsgesuch wurde erfolgreich versendet",
    },
    bookings: {
      add_booking: "Deine Buchung wurde erfolgreich gespeichert",
      delete_booking: "Deine Buchung wurde gelöscht",
    },
    expenses: {
      add_expense: "Deine Auslage wurde erfolgreich gespeichert",
      delete_expense: "Deine Auslage wurde erfolgreich gelöscht",
    },
    usage_logs: {
      add_usage: "Dein Logeintrag wurde erfolgreich gespeichert",
      delete_usage_log: "Dein Logeintrag wurde erfolgreich gelöscht",
    },
    circle_request: {
      send_request: "Dein Beitrittsgesuch wurde versandt",
    },
    my_circles: {
      migrate: "Members successfully migrated",
    },
  },
  messages: {
    title: "Du hast noch keine Mitteilungen erhalten",
    description: "Mach doch den ersten Schritt und kontaktiere Leute die interessante Gruppen gestartet haben.",
    write_first_message: "Starte die Konversation mit einem einfachen … Hallo, ich bin ...",
    create_circle: "Starte deine erste Gruppe",
    message_input_placeholder: "Schreib was...",
  },
  admin_tabs: {
    log: "Logbuch",
    chat: "Chat",
    booking: "Kalender",
    expenses: "Spesen",
    agreement: "Vereinbarung",
  },
  agreement: {
    and: "und",
  },
  agreement_modal: {
    title: "Vereinbarung",
  },
  or: "oder",
  circle_form: { create_circle: "Kaufgruppe" },
  cookie_banner: "Diese Webseite verwendet Cookies um deine Erfahrung zu verbessern. ",
  i_understand: "Ich stimme der Verwendung zu",
  password_score: {
    too_short: "zu kurz",
    weak: "unsicher",
    okay: "ok",
    good: "gut",
    strong: "sicher",
    stronger: "sehr sicher",
  },
  custom_landing: {
    landing_automower: {
      buy_with_neighbours: "Kaufe mit deinen Nachbarn",
      learn_more: "Mehr erfahren",
      in_collaboration: "In Zusammenarbeit mit",
    },
    landing_othergardening: {
      buy_with_neighbours: "Kaufe mit deinen Nachbarn",
      sell_share: "Verkaufe ein Nutzungsrecht an deinen Maschinen",
      in_collaboration: "In Zusammenarbeit mit",
    },
    landing_existing_owner: {
      start_sharing: "Jetzt Funktionen nutzen",
      get_started: "Starte jetzt",
      post_boat_free: "Liste dein Boot. Kostenfrei. ",
      sell_part_post_boat: "Liste dein Boot. Kostenfrei.",
      sell_part_get_started: "Starte jetzt",
      selling_points_header: "Wieso ihopa?",
      selling_points_safe_sharing: "Sicheres Teilen",
      selling_points_safe_sharing_content: "Bindende Vereinbarung und Versicherung",
      selling_points_easy_sharing: "Einfaches Teilen",
      selling_points_easy_sharing_content: "Buchungskalender, Spesen, Logbuch,...",
      selling_points_post_free: "Dein Boot jetzt kostenfrei listen",
      selling_points_post_free_content: "und passende Miteigentümer finden.",
    },
    landing_buy_boat: {
      buy_boat: "Verwirkliche einen Bootstraum. Zusammen mit deinen Freunden.",
      buy_existing: "Werde Teilhaber eines Bootes",
    },
    landing_cool_stuff: {
      start_circle: "Gruppe starten",
      browse_circles: "Offene Gruppen browsen",
    },
  },
  whitemonday: {
    landing_whitemonday: {
      create_gift: "Erstelle dein Geschenk",
      learn_more: "Mehr erfahren",
      not_sure: "Noch nicht überzeugt?",
      people: "Leute",
    },
    puzzle_gift: {
      title: "Puzzle Geschenkkarte bestellen",
      header: "Puzzle Geschenkkarte bestellen",
      subheading: "Wir schicken dir eine Puzzle - Geschenkkarte. Kostenfrei. ",
      form_header: "Wohin sollen wir die Geschenkkarte schicken?",
      form_p1:
        "Hier kannst du eine Puzzle-Geschenkkarte bestellen. Die Idee dahinter ist dass jeder der einen Teil deines Produktes geschenkt bekommt einen Teil des Puzzles erhält. Nur jetzt und für kurze Zeit ist diese Geschenkkarte und der Versand komplett kostenfrei.",
      form_p2_1: "- Wir werden das Foto dass du hochgeladen hast oder eine ähnliche Illustration verwenden.",
      form_p2_2: "- Wir senden es an die angegebene Adresse innerhalb von 7 Arbeitstagen.",
      form_p3:
        "Während der Weihnachtszeit bekommen ist die Post immer ein bisschen langsamer und der Versand könnte sich ein wenig verspäten.",
      form_p4_1: "Noch Fragen? Kein Problem, wir sind erreichbar.",
      form_p4_2: " Kontaktiere uns",
      send_order: "Bestellung abschließen",
    },
    placeholders: {
      address: "Deine Adresse",
      name: "Dein voller Name",
    },
    errors: {
      send_puzzle_form: {
        name: "Bitte gib deinen Namen an damit wir dir die Geschenkkarte schicken können.",
        location: "Bitte gib deine Adresse an damit wir dir die Geschenkkarte schicken können. ",
        send_request_error:
          "Hoppla. Da ist was mit deiner Bestellung schiefgelaufen. Bitte versuchs nochmal oder kontaktiere uns.",
      },
    },
    success: {
      request_puzzle: {
        success: "Deine Bestellung wurde erfolgreich empfangen.",
      },
    },
    print_gift_card: {
      title: "Geschenkkarte ausdrucken",
      header: "Geschenkkarte ausdrucken",
      subheading: "Drucke deine Geschenkkarte selbst aus ",
      print_card: "Geschenkkarte ausdrucken",
      give_part: "schenkt dir einen Teil von etwas Persönlichen. Gut für dich und die Umwelt.",
    },
  },
  b2b: {
    go_back: "Schritt zurück",
    create_group: "Jetzt eine Kaufgruppe starten",
    buy_with_friends: "Zusammen kaufen",
    use_together: "Zusammen kaufen und nutzen.",
    mark_your_interest: "Interesse bekunden",
    share_your_group: "Teile deine Gruppe",
    select_owners_number: "Wie viele Miteigentümer soll die Gruppe haben ",
    co_owners: "Miteigentümer",
    per_owner: "pro Person",
    build_group: "Fülle deine Gruppe",
    buy_together: "Zusammen kaufen",
    enjoy_together: "Zusammen genießen",
    non_binding: "Nicht bindend - Keine Kreditkarte notwendig.",
    setup_group: "Jetzt Kaufgruppe starten",
    take_me_back: "Bring mich zurück zur Produktseite",
    invite_your_friends: "Lade deine Freunde und Bekannten ein",
    match_with_people: "oder finde passende Teilhaber in deiner Nähe",
    sharing_agreement: "Vereinbarung",
    group_insurance: "Versicherung",
    booking_calendar: "Buchungskalender",
    group_chat: "Gruppenchat",
    expense_sharing: "Spesen teilen",
    maintenance_logs: "Logbuch",
    what_kind_of_group: "Welche Art von Gruppe?",
    what_kind_of_group_note:
      "Achtung: Einer Gruppe zu erstellen oder beizutreten verpflichtet zu nichts. Du kannst die Gruppe jederzeit verlassen bevor du die Vereinbarung unterschreibst. ",
    start_friend_group: "Starte eine Freundesgruppe",
    start_friend_group_copy: "Starte eine private Gruppe und lade deine Freunde zum Teilen ein.",
    start_public_group: "Starte eine öffentliche Gruppe",
    start_public_group_copy: "Starte eine öffentlich Gruppe und finde passende Teilhaber in deiner Umgebung",
    send_invites: "Freiwillig: Teile die Gruppe mit deinen Freunden ",
    share_group: "Nutze deine Social Media Reichweite um deine Bekannten zum Teilen einzuladen.",
    interested_not_ready: "Interessiert aber noch nicht ganz überzeugt?",
    interested_not_ready_copy:
      "Lass uns wissen dass du interessiert bist und wir informieren dich über passende Gruppen in deiner Umgebung.",
    members_no_helper: "%{members_no} Miteigentümer, ",
    change_members_no: " pro Person. Zum Ändern hier klicken",
    add_new_friend: "Neuen Freund hinzufügen",
    phone: "Telefonnummer",
    invalid_phone_number: "Ungültige Telefonnummer",
    mark_interest_an_close: "Interesse bekunden und Zurück zur Produktseite",
    add_location: "Bitte gib deinen Standort an damit wir Gruppen in deiner Nähe finden.",
    share_step_copy:
      "Deine Gruppe wurde erfolgreich erstellt und du kannst sie jetzt mit deinen Freunden, Bekannten oder Nachbarn teilen.",
  },
  no_image: "Kein Bild hinzugefügt",
  minute: "Minute",
  hour: "Stunde",
  day: "Tag",
  week: "Woche",
  minutes: "Protokoll",
  hours: "Stunden",
  days: "Tage",
  weeks: "Wochen",
  prypool: {
    bundle_products: "Bundle products",
    unavailable_products: "Unavailable products",
    available_products: "Available products",
    checkout: "Checkout",
    thank_for_using: "Thank you for using our service and enjoy your items",
    back: "Back to products",
    transaction_successful: "Betalning lyckades och därmed vill vi varmt välkomna dig som medlem i ihopa Grannbox!",
    success_messages1:
      "Du har nu fått ett email från <a href='mailto:info@ihopa.com'>info@ihopa.com</a> med viktiga instruktioner samt länk till att välja lösenord så att du kan komma igång och boka produkterna. Om du inte hittar emailet, titta i din spam-folder och om det hamnat där, markera att det inte är spam så du får mail i fortsättningen.",
    success_messages2: "Stort tack.",
    price: "Price %{price}/month",
    price_month: "%{price}/month",
    address: "Address",
    get_access: "Get access now",
  },
  rental: {
    rental_price: "Rental price: ",
    transaction_successful:"You have successful rented this product. Please download the mobile app in order to access it.",
    rental:"Rental",
    download_on_app_store: "Download on App Store",
    download_on_google_play: "Download on Google Play"
  }
};

export default de;
